import { Role } from '@/core/components/auth/auth.types'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/site-customization/emails/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})
